import TrashDeleteBtn from "../../../components/TrashDeleteBtn";
import { nullFormatter, numberFormatter, dateFormatter, expiredDateFormatter } from "../../gridFormatters";
import { numberParser } from "../../Helpers";

export const enterpriseCapacityPlanDefs = [
    {
        "field": "collection_date",
        "headerName": "Month",
        "sort": "desc",
        "sortingOrder": ['desc','asc'],
        "cellRenderer": dateFormatter
    },
    {
        "field": "used",
        "type": "numericColumn",
        "headerName": "Used",
        "cellRenderer": numberFormatter
    },
    {
        "field": "effective_capacity",
        "type": "numericColumn",
        "headerName": "Effective Capacity",
        "cellRenderer": numberFormatter
    },
    {
        "field": "subscription_capacity",
        "type": "numericColumn",
        "headerName": "80% Threshold",
        "cellRenderer": numberFormatter
    },
    {
        "field": "order_capacity",
        "type": "numericColumn",
        "headerName": "70% Threshold",
        "cellRenderer": numberFormatter
    }
];

export const enterpriseCapacityPlanPhyDefs = [
    {
        "field": "collection_date",
        "headerName": "Month",
        "sort": "desc",
        "sortingOrder": ['desc','asc'],
        "cellRenderer": dateFormatter
    },
    {
        "field": "physical_used",
        "type": "numericColumn",
        "headerName": "Physical Used",
        "cellRenderer": numberFormatter
    },
    {
        "field": "physical_effective_capacity",
        "type": "numericColumn",
        "headerName": "Physical Effective Capacity",
        "cellRenderer": numberFormatter
    },
    {
        "field": "physical_subscription_capacity",
        "type": "numericColumn",
        "headerName": "Physical 80% Threshold",
        "cellRenderer": numberFormatter
    },
    {
        "field": "physical_order_capacity",
        "type": "numericColumn",
        "headerName": "Physical 70% Threshold",
        "cellRenderer": numberFormatter
    }
];

export const getUserInputDefs = (months) => [
    {
        "field": "month",
        "headerName": "Date",
        "cellRenderer": expiredDateFormatter,
        "editable": true,
        "cellEditor": 'agSelectCellEditor',
        "cellEditorParams": {
            values: months.map((m) => m.value)
        }
    },
    {
        "field": "capacity",
        "type": "numericColumn",
        "headerName": "Capacity (GiB)",
        "cellRenderer": numberFormatter,
        "editable": true,
        "cellEditor": "agNumberCellEditor",
        "valueParser": numberParser
    },
    {
        "field": "workload",
        "type": "numericColumn",
        "headerName": "Workload (GiB)",
        "cellRenderer": numberFormatter,
        "editable": true,
        "cellEditor": "agNumberCellEditor",
        "valueParser": numberParser
    },
    {
        "field": "growth",
        "type": "numericColumn",
        "headerName": "Growth",
        "cellRenderer": function ({ value, data }) {
            if (!value) return '';
            return `${numberFormatter({value})} ${data.growthType === "growth" ? '%' : 'GiB/Mo'}`
        },
        "editable": true,
        "cellEditor": "agNumberCellEditor",
        "valueParser": numberParser
    },
    {
        "field": "notes",
        "headerName": "Planning Notes",
        "editable": true,
        "cellEditor": "agTextCellEditor"
    },
    {
      "headerName": 'Delete',
      "cellRenderer": TrashDeleteBtn,
      "editable": false
    }
]
